import React from 'react';
import { Modal, Form, Select, Spin } from 'antd';

const { Option } = Select;

// A list of sample issues that can be added.
const ALL_POSSIBLE_ISSUES = [
  'Issue 1',
  'Issue 2',
  'Issue 3',
  'Issue 4',
  'Issue 5',
  'Common Issue 1',
  'Common Issue 2',
];

const AddIssueModal = ({ visible, onCancel, onOk, allIssues, issuesLoading }) => {
  const [form] = Form.useForm();

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        onOk(values.issue);
        form.resetFields();
      })
      .catch((info) => {
        console.log('Validate Failed:', info);
      });
  };

  // Handle the API response structure - data might be in rows array or direct array
  const availableIssues = allIssues?.rows || allIssues || [];

  // Debug logging
  return (
    <Modal
      visible={visible}
      title="Add new issue"
      onCancel={onCancel}
      onOk={handleOk}
      okText="OK"
      cancelText="Cancel"
      destroyOnClose
      confirmLoading={issuesLoading}
    >
      <Spin spinning={issuesLoading}>
        <Form
          form={form}
          layout="vertical"
        >
          <Form.Item
            name="issue"
            label="Select Issue"
            rules={[{ required: true, message: 'Please select an issue!' }]}
          >
            <Select
              placeholder="Select Issue"
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {availableIssues.map((issue) => (
                <Option
                  key={issue.id}
                  value={issue.id}
                >
                  {issue.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Spin>
    </Modal>
  );
};

export default AddIssueModal;
